module.exports = __webpack_public_path__ + "static/img/43489051_l.6204e9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/help/43489051_l.jpg
// module id = ak5t
// module chunks = 6